'use strict';

/**
 * Parameter Service
 */
module.service('parameterService', [ 'Restangular', '$q', function(Restangular, $q) {

    /*
     * ------------------------------------------------------------------------------
     * SERVICE FUNCTIONS
     * -------------------------------------------------------------------------------
     */

    var defaultCurrency = null;

    var defaultCountry = null;
    
    var defaultIdentificationType = null;

    var countries = null;

    var parameterResource = Restangular.all('parameter');

    return {

        getParameter : function(idParameter){
            var deferred = $q.defer();
            var answer = new restResponse();

            parameterResource.get(idParameter).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        searchParameters : function(filters) {
            var deferred = $q.defer();
            var answer = new restResponse();

            var parameterResource = Restangular.all('parameter');

            parameterResource.customGET('', filters).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        createParameter : function(parameter) {
            var deferred = $q.defer();
            var answer = new restResponse();

            parameterResource.post(parameter).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });

            return deferred.promise;
        },

        updateParameter : function(idParameter, parameter) {
            var deferred = $q.defer();
            var answer = new restResponse();


            parameterResource.customPUT(parameter, '' + idParameter).then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        getCountries : function() {
            var deferred = $q.defer();
            var answer = new restResponse();
            var parameterResource = Restangular.all('country');

            // GET to /country
            parameterResource.getList().then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        getCities : function(idCountry) {
            var deferred = $q.defer();
            var answer = new restResponse();

            // GET to /country/{id}/city
            Restangular.one('country', idCountry).getList('city').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        getParametersByType : function(type) {
            var deferred = $q.defer();
            var answer = new restResponse();

            // GET to /parameter/{type}
            Restangular.one('parameter', type).getList().then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        getFrequencies : function() {
            var deferred = $q.defer();
            var answer = new restResponse();
            var resource = Restangular.all('frequency');

            // GET to /frequencies
            resource.getList().then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                deferred.resolve(answer);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },

        getDefaultCountry : function() {
            var deferred = $q.defer();
            var answer = new restResponse();

            if (defaultCountry != null) {
                answer.handleSuccessfullResponse(null, defaultCountry);
                deferred.resolve(answer);
            } else {

                Restangular.one('country').customGET('default').then(function(response) {
                    defaultCountry = response.data;

                    answer.handleSuccessfullResponse(response, response.data);
                    deferred.resolve(answer);
                }, function(response) {
                    answer.handleErrorResponse(response, response.data);
                    deferred.reject(answer);
                });
            }
            return deferred.promise;
        },

        getDefaultIdentificationType : function() {
            var deferred = $q.defer();
            var answer = new restResponse();

            if (defaultIdentificationType != null) {
                answer.handleSuccessfullResponse(null, defaultIdentificationType);
                deferred.resolve(answer);
            } else {

                // GET to /frequencies
                Restangular.one('parameter/identificationtype').customGET('default').then(function(response) {
                	defaultIdentificationType = response.data;

                    answer.handleSuccessfullResponse(response, response.data);
                    deferred.resolve(answer);
                }, function(response) {
                    answer.handleErrorResponse(response, response.data);
                    deferred.reject(answer);
                });
            }
            return deferred.promise;
        }

    };
} ]);